import React, { Component } from 'react';
import gameConfig from './api/serious-game';
import SeriousGame from './components/SeriousGame';
import MobileDetect from 'mobile-detect';


class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      wording: {},
      cssTheme: 'default',
      themeList: [],
      resultList: [],
      questionList: [],
      optinList: [],
      dontCheckEmail: false,
      emailFocus: false
    };

    this.handleFocusEmail = this.handleFocusEmail.bind(this);
    this.handleBlurEmail = this.handleBlurEmail.bind(this);
  }

  componentWillMount() {
    this.setState({
      wording: gameConfig.wording,
      cssTheme: gameConfig.cssTheme,
      themeList: gameConfig.themeList,
      resultList: gameConfig.resultList,
      questionList: gameConfig.questionList,
      optinList: gameConfig.optinList,
      dontCheckEmail: gameConfig.dontCheckEmail
    });
  }

  handleFocusEmail(){
    this.setState({
      emailFocus: true
    });
  }

  handleBlurEmail(){
    this.setState({
      emailFocus: false
    });
  }

  render() {
    var md = new MobileDetect(window.navigator.userAgent);
    var className = "idix_seriousgame-app";
    if(md.is('iPhone')){
      className += " idix_seriousgame-iphone";
    }
    if(md.phone() !== null && this.state.emailFocus){
      className += " idix_seriousgame-emailfocus";
    }

    return (
      <div className={className}>
        <SeriousGame
            wording={this.state.wording}
            cssTheme={this.state.cssTheme}
            themeList={this.state.themeList}
            resultList={this.state.resultList}
            questionList={this.state.questionList}
            optinList={this.state.optinList}
            changeScreenCallback={this.props.changeScreenCallback}
            loginInfoCallback={this.props.loginInfoCallback}
            saveResultCallback={this.props.saveResultCallback}
            handleFocusEmail={this.handleFocusEmail}
            handleBlurEmail={this.handleBlurEmail}
            dontCheckEmail={this.state.dontCheckEmail}
        />
      </div>
    );
  }
}

App.propTypes = {
  changeScreenCallback: React.PropTypes.func,
  loginInfoCallback: React.PropTypes.func,
  saveResultCallback: React.PropTypes.func
};

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/